function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientBillStatusApi, clientFileDeleteApi, clientInvoiceStatusApi, putInvalid, clientInvoiceStatus } from '@/api/enterprise';
import SettingMer from '@/libs/settingMer';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { getToken } from '@/utils/auth';
import file from '@/utils/file';
import Vue from 'vue';
Vue.use(file);
export default {
  name: 'ExamineDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ElImageViewer: ElImageViewer
  },
  data: function data() {
    return {
      remarks: '',
      radio: 1,
      isSend: 1,
      num: '',
      invoice_type: '',
      invoice_address: '',
      examineVisible: false,
      loading: false,
      title1: '',
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      methodOptions: [{
        value: 'express',
        label: this.$t('customer.express')
      }, {
        value: 'mail',
        label: this.$t('customer.mail')
      }],
      uploadData: {},
      uploadList: [],
      uploadSize: 5,
      disabled: false,
      isImage: false,
      srcList: []
    };
  },
  computed: {
    fileUrl: function fileUrl() {
      return SettingMer.https + "/client/file/upload";
    }
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        if (nVal.type === 1) {
          this.title1 = this.$t('customer.fundaudit');
        } else if (nVal.type === 2) {
          this.title1 = this.$t('customer.invoicereview');
        } else {
          if (nVal.data.num) {
            this.radio = 1;
          } else {
            this.radio = 2;
          }
          this.title1 = this.$t('customer.invoicingapproval');
        }
      },
      deep: true
    }
  },
  methods: {
    handleOpen: function handleOpen() {
      this.examineVisible = true;
    },
    handleClose: function handleClose() {
      this.examineVisible = false;
      this.reset();
    },
    handleConfirm: function handleConfirm() {
      var file = [];
      if (this.radio === 2 && !this.remarks) {
        this.$message.error(this.$t('customer.placeholder18'));
      } else if (this.config.type === 3 && this.radio === 1 && !this.num) {
        this.$message.error('请输入发票编号');
      } else if (this.config.type === 3 && this.radio === 1 && !this.invoice_address) {
        if (this.invoice_type === 'express') {
          this.$message.error('请输入邮寄地址');
        } else {
          this.$message.error('请输入邮箱地址');
        }
      } else {
        var data = {
          status: this.radio
        };
        if (this.config.type === 1) {
          var mark = '';
          data.fail_msg = this.remarks;
          if (this.config.data.types === 1) {
            if (this.config.data.treaty) {
              mark = this.config.data.treaty.title + '-' + this.config.data.renew.title;
            }
          } else {
            if (this.config.data.treaty) {
              mark = this.config.data.treaty.title + '-' + this.$t('customer.Contractpayment');
            }
          }
          data.mark = mark;
          this.getBillStatus(this.config.data.id, data);
        } else if (this.config.type === 2) {
          if (this.config.title === '作废审核') {
            var status = '';
            if (this.radio == 1) {
              status = 2;
            } else {
              status = 3;
            }
            var _data = {
              remark: this.remarks,
              invalid: status
            };
            this.putInvalid(this.config.data.id, _data);
          } else {
            data.remark = this.remarks;
            this.invoiceStatus(this.config.data.id, data);
          }
        } else if (this.config.type === 3) {
          data.status = 3;
          data.remark = this.remarks;
          data.invoice_address = this.invoice_address;
          data.invoice_type = this.invoice_type;
          data.num = this.num;
          data.is_send = this.config.data.collect_type === 'mail' ? this.isSend : 0;
          if (this.uploadList.length > 0) {
            this.uploadList.map(function (value) {
              file.push(value.id);
            });
          }
          data.file = file;
          this.invoiceStatus(this.config.data.id, data);
        }
      }
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    },
    // 作废审核
    putInvalid: function putInvalid(id, data) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return clientInvoiceStatus(id, data);
            case 2:
              _this.$emit('isOk');
              _this.handleClose();
              _this.loading = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 删除附件
    handleFileDelete: function handleFileDelete(row, index) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return clientFileDeleteApi(row.id);
            case 2:
              _this2.uploadList.splice(index, 1);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 上传前
    handleUpload: function handleUpload(file) {
      var types = ['jpeg', 'gif', 'bmp', 'png', 'jpg', 'doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx', 'txt', 'pdf'];
      this.uploadData.cid = this.config.data.cid;
      this.uploadData.eid = this.config.data.eid;
      var fileTypeName = file.name.substr(file.name.lastIndexOf('.') + 1);
      var isImage = types.includes(fileTypeName);
      var isLtSize = file.size / 1024 / 1024 < this.uploadSize;
      if (!isImage) {
        this.$message.error('不支持该' + fileTypeName + '格式');
        return false;
      }
      if (!isLtSize) {
        this.$message.error('上传图片大小不能超过 ' + this.uploadSize + ' MB!');
        return false;
      }
      return true;
    },
    // 上传成功
    handleSuccess: function handleSuccess(response) {
      if (response.status === 200) {
        this.uploadList.push({
          path: response.data.path,
          id: response.data.id,
          type: response.data.type,
          name: response.data.name
        });
        this.$message.success(response.message);
      } else {
        this.$message.error(response.message);
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(row) {
      var fileType = row.name.substr(row.name.lastIndexOf('.') + 1);
      var types = ['jpeg', 'gif', 'bmp', 'png', 'jpg'];
      var isImage = types.includes(fileType);
      if (isImage) {
        this.isImage = true;
        this.srcList.push(row.path);
      }
    },
    // 资金审核
    getBillStatus: function getBillStatus(id, data) {
      var _this3 = this;
      this.loading = true;
      clientBillStatusApi(id, data).then(function (res) {
        _this3.$emit('isOk');
        _this3.handleClose();
        _this3.loading = false;
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    // 发票审核
    invoiceStatus: function invoiceStatus(id, data) {
      var _this4 = this;
      this.loading = true;
      clientInvoiceStatusApi(id, data).then(function (res) {
        _this4.$emit('isOk');
        _this4.handleClose();
        _this4.loading = false;
      }).catch(function (error) {
        _this4.loading = false;
      });
    },
    reset: function reset() {
      this.remarks = '';
      this.radio = 1;
      this.isSend = 1;
      this.num = '';
      this.invoice_type = '';
      this.invoice_address = '';
      this.uploadList = [];
    },
    handleMethod: function handleMethod(e) {
      var nameTel = this.config.data.collect_name + '-' + this.config.data.collect_tel;
      if (e === this.config.data.collect_type) {
        if (e === 'express') {
          this.invoice_address = nameTel + '-' + this.config.data.collect_email;
        } else {
          this.invoice_address = this.config.data.collect_email;
        }
      } else {
        if (e === 'express') {
          this.invoice_address = nameTel + '-';
        } else {
          this.invoice_address = '';
        }
      }
    }
  }
};